module.exports = {
	parseFromFolio: (folio) => {
		let passport = {};
		if (folio.DocumentList && folio.DocumentList.Document) {
			if (folio.DocumentList.Document.length) {
				passport = folio.DocumentList.Document
					.filter(doc => { return doc.Type === 'P' })[0]
			}
			else if (folio.DocumentList.Document &&
			folio.DocumentList.Document.Type === 'P') {
				passport = folio.DocumentList.Document;
			}
		}
		return passport;
	},
	isComplete: (passport) => {
		if (passport.DocumentId === null || passport.IssueCountry === null || passport.No === null ||
			passport.IssueDate === null || passport.ExpiryDate === null) return false;
		else return true;
	}
};


// WEBPACK FOOTER //
// ./portal-components/passportUtils/index.js